import { useContext } from "react"

//Styles
import myStyles from "../../../../../styles/referrals/ReferralEntityFormChangeRequestItem.module.css"

// Context
import { UserContext } from "../../../../../context/userContext"

//PrimeReact
import { Button } from "primereact/button"
import { confirmPopup } from "primereact/confirmpopup" // To use confirmPopup method

//Helper
import { displayLocalDateTimeFromIso } from "../../../../../helpers/displayDates"

export default function ReferralEntityFormChangeRequestItem({
  changeRequestItem,
  isLoading,
  onProcessRequest,
}) {
  const userCtx = useContext(UserContext)
  const staff_id = userCtx.session.user.staff_id
  const staff_role = userCtx.session.user.staff_role

  const isPartner = staff_role === 9 || staff_role === 10
  let status = ""
  let statusStyle = ""

  if (changeRequestItem.accepted === true) {
    status = "Accepted"
    statusStyle = myStyles.acceptBackground
  } else if (changeRequestItem.accepted === false) {
    status = "Declined"
    statusStyle = myStyles.declineBackground
  }

  const GetCancelButtons = () => {
    if (staff_id === changeRequestItem.requestUserId || isPartner) {
      return (
        <div style={{ width: "100%" }}>
          <Button
            type="button"
            onClick={(event) => {
              if (!isPartner) {
                confirmPopup({
                  target: event.currentTarget,
                  message: "Are you sure you want to proceed?",
                  icon: "pi pi-exclamation-triangle",
                  accept: () => {
                    onProcessRequest(changeRequestItem, false)
                  },
                  reject: () => {},
                })
              } else {
                onProcessRequest(changeRequestItem, false)
              }
            }}
            className={myStyles.button}
            disabled={isLoading}
            style={{ float: "right" }}
          >
            {staff_id === changeRequestItem.requestUserId
              ? "Cancel"
              : "Decline"}
          </Button>
        </div>
      )
    } else {
      return null
    }
  }

  const GetSubmitButtons = () => {
    if (staff_role === 9 || staff_role === 10) {
      return (
        <>
          <div style={{ width: "100%" }}>
            <Button
              type="button"
              onClick={(event) => {
                if (!isPartner) {
                  confirmPopup({
                    target: event.currentTarget,
                    message: "Are you sure you want to apply this change?",
                    icon: "pi pi-exclamation-triangle",
                    accept: () => {
                      onProcessRequest(changeRequestItem, true)
                    },
                    reject: () => {},
                  })
                } else {
                  onProcessRequest(changeRequestItem, true)
                }
              }}
              className={myStyles.button}
              disabled={isLoading}
              style={{ float: "right" }}
            >
              Accept
            </Button>
          </div>
        </>
      )
    } else {
      return null
    }
  }

  return (
    <div className={myStyles.requestItemGridContainer}>
      <div className={myStyles.requestItemType}>
        <span className={myStyles.fieldTitle}>Change type: </span>
        {!!changeRequestItem.referralLocationId
          ? `(Location) ${changeRequestItem.referralLocationName || "Unknown"}`
          : "Profile"}
      </div>
      <div className={myStyles.requestItemStatus}>
        <span className={statusStyle}>{status}</span>
      </div>
      <div className={myStyles.requestItemDate}>
        <span className={myStyles.fieldTitle}>Date: </span>
        {displayLocalDateTimeFromIso(changeRequestItem.creationDate)}
      </div>
      <div className={myStyles.requestItemField}>
        <span className={myStyles.fieldTitle}>Field name: </span>
        {changeRequestItem.fieldName}
      </div>
      {changeRequestItem.fieldName !== "ServiceType" ? (
        <div className={myStyles.requestItemCurrentValue}>
          <span className={myStyles.fieldTitle}>Original value: </span>
          {changeRequestItem.currentValue}
        </div>
      ) : null}
      <div className={myStyles.requestItemNewValue}>
        <span className={myStyles.fieldTitle}>New value: </span>
        {changeRequestItem.newValue}
      </div>
      <div className={myStyles.requestItemRequestOrg}>
        <span className={myStyles.fieldTitle}>Organization: </span>
        {changeRequestItem.requestOrganizationName}
      </div>
      <div className={myStyles.requestItemRequestUser}>
        <span className={myStyles.fieldTitle}>Staff: </span>
        {changeRequestItem.requestUserName}
      </div>
      <div className={myStyles.requestItemButtons}>
        <GetCancelButtons />
      </div>
      <div className={myStyles.requestItemButtonAccept}>
        <GetSubmitButtons />
      </div>
    </div>
  )
}
